import axios from 'axios'

const TOKEN_KEY = 'loop_cast_receiver_token'
const SESSION_KEY = 'loop_cast_session_id'
const PAIR_CODE_KEY = 'loop_cast_pair_code'
const PAIR_EXPIRES_KEY = 'loop_cast_pair_expires_at'

const client = axios.create({
  baseURL: process.env.VUE_APP_CAST_API_BASE || '/api',
  timeout: 10000,
  headers: { 'Content-Type': 'application/json' },
})

function tokenHeader(token) {
  return { Authorization: `Cast ${token}` }
}

export function createReceiver(receiverName) {
  return client.post('/videoCourse/cast/receiver/session', {
    receiver_name: receiverName,
  }).then(response => response.data)
}

export function pollReceiver(token, lastAppliedVersion, needsLoad) {
  return client.post('/videoCourse/cast/receiver/poll', {
    last_applied_version: lastAppliedVersion,
    needs_load: !!needsLoad,
  }, { headers: tokenHeader(token) }).then(response => response.data)
}

export function reportReceiver(token, state, lastAppliedVersion) {
  return client.post('/videoCourse/cast/receiver/report', {
    lesson_id: state.lessonId || 0,
    position_seconds: Math.max(0, Math.floor(state.position || 0)),
    duration_seconds: Math.max(0, Math.floor(state.duration || 0)),
    volume_percent: Math.max(0, Math.min(100, Math.round(state.volume || 0))),
    speed: state.speed || 1,
    is_playing: !!state.isPlaying,
    error_message: state.errorMessage || '',
    last_applied_version: lastAppliedVersion,
  }, { headers: tokenHeader(token) }).then(response => response.data)
}

export function closeReceiver(token) {
  return client.post('/videoCourse/cast/receiver/close', {}, {
    headers: tokenHeader(token),
  }).then(response => response.data)
}

export function saveReceiverSession(token, sessionId, pairCode = '', expiresAt = 0) {
  sessionStorage.setItem(TOKEN_KEY, token)
  sessionStorage.setItem(SESSION_KEY, sessionId)
  if (pairCode && expiresAt) {
    sessionStorage.setItem(PAIR_CODE_KEY, pairCode)
    sessionStorage.setItem(PAIR_EXPIRES_KEY, String(expiresAt))
  } else {
    sessionStorage.removeItem(PAIR_CODE_KEY)
    sessionStorage.removeItem(PAIR_EXPIRES_KEY)
  }
}

export function loadReceiverSession() {
  return {
    token: sessionStorage.getItem(TOKEN_KEY) || '',
    sessionId: sessionStorage.getItem(SESSION_KEY) || '',
    pairCode: sessionStorage.getItem(PAIR_CODE_KEY) || '',
    expiresAt: Number(sessionStorage.getItem(PAIR_EXPIRES_KEY) || 0),
  }
}

export function clearReceiverSession() {
  sessionStorage.removeItem(TOKEN_KEY)
  sessionStorage.removeItem(SESSION_KEY)
  sessionStorage.removeItem(PAIR_CODE_KEY)
  sessionStorage.removeItem(PAIR_EXPIRES_KEY)
}

export function receiverErrorMessage(error, fallback) {
  const response = error && error.response
  return (response && response.data && response.data.message) || fallback
}
